import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TokenService } from '../services/tokenService';

const LoginScreen: React.FC = () => {
  const navigate = useNavigate();

  // Check if user is already logged in
  useEffect(() => {
    const savedToken = TokenService.getToken();
    if (savedToken && TokenService.hasValidToken()) {
      console.log('🔑 User already logged in, redirecting to app');
      navigate('/app');
    }
  }, [navigate]);

  return (
    <div className="login-screen">
      <div className="login-container">
        {/* Fleefer Logo and Title */}
        <div className="login-header">
          <div className="login-logo">
            <img src="/fleefer.png" alt="Fleefer" className="fleefer-logo" />
          </div>
          <h1 className="login-title">welcome to fleefer</h1>
        </div>

        {/* Login Form */}
        <div className="login-form-container">
          <div className="login-card">
            <h2 className="login-form-title">🔐 Authentication Required</h2>

            {/* Google OAuth Login */}
            <div className="oauth-section">
              <button
                type="button"
                onClick={() => window.location.href = `${process.env.REACT_APP_BACKEND_URL}/auth/google`}
                className="google-login-btn"
                disabled={false}
              >
                <svg className="google-icon" viewBox="0 0 24 24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                Continue with Google
              </button>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="login-footer">
          <p>Bei Risiken und Nebenwirkungen fragen Sie Ihren Arzt oder Apotheker.</p>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen; 